var map = {
	"./AHSAFNAME.png": 45,
	"./ahsafdp.png": 1876,
	"./app.png": 7298,
	"./app2.png": 8538,
	"./applelogo.png": 5742,
	"./arrow.png": 4504,
	"./backArrow.svg": 3321,
	"./backend.png": 5443,
	"./behance.png": 3511,
	"./downloadnow.png": 5115,
	"./dribble.png": 4289,
	"./favlabel.png": 8932,
	"./focusCard": 1049,
	"./focusCard.js": 1049,
	"./focusCard.png": 5377,
	"./forfun.png": 9343,
	"./fromheart.png": 5383,
	"./graphicsdesigner.png": 6343,
	"./iam.png": 5984,
	"./icons8-app-store.svg": 1587,
	"./icons8-github.svg": 9303,
	"./icons8-play-store.svg": 2371,
	"./instagram.png": 7543,
	"./iwish.png": 7511,
	"./leftArrow.svg": 5279,
	"./linkedin.png": 5405,
	"./logo.png": 2806,
	"./mobileicon.png": 1910,
	"./nodejs.png": 4853,
	"./photographer.png": 1350,
	"./projects/bill1.png": 2432,
	"./projects/bill2.png": 2283,
	"./projects/bill3.png": 1154,
	"./projects/bill4.png": 7501,
	"./projects/bill5.png": 6372,
	"./projects/bill6.png": 7660,
	"./projects/bill7.png": 6262,
	"./projects/billieselogo.png": 9318,
	"./projects/cowallet1.webp": 1834,
	"./projects/cowallet2.webp": 8683,
	"./projects/cowallet3.webp": 2232,
	"./projects/cowallet4.webp": 801,
	"./projects/cowallet5.webp": 7174,
	"./projects/cowallet6.webp": 4551,
	"./projects/cowallet7.webp": 1540,
	"./projects/cowallet8.webp": 7597,
	"./projects/cowalletlogo.png": 1206,
	"./projects/edu1.webp": 3407,
	"./projects/edu2.webp": 6254,
	"./projects/edu3.webp": 7145,
	"./projects/edu4.webp": 8000,
	"./projects/edu5.webp": 5491,
	"./projects/edu6.webp": 8066,
	"./projects/edu7.webp": 1085,
	"./projects/edumpusbanner.png": 3473,
	"./projects/edumpusmobile.png": 1445,
	"./projects/fly1.webp": 7616,
	"./projects/fly2.webp": 2285,
	"./projects/fly3.webp": 7346,
	"./projects/fly4.webp": 6895,
	"./projects/flytalklogo.png": 5844,
	"./projects/lucky1.png": 2195,
	"./projects/lucky2.png": 5336,
	"./projects/lucky3.png": 9201,
	"./projects/lucky4.png": 2462,
	"./projects/lucky5.png": 4951,
	"./projects/lucky6.png": 5948,
	"./projects/lucky7.png": 8213,
	"./projects/luckyhandbanner.png": 7693,
	"./projects/luckyhandlogo.png": 2754,
	"./projects/maziplay.png": 313,
	"./projects/naif1.webp": 2229,
	"./projects/naif2.webp": 7832,
	"./projects/naif3.webp": 651,
	"./projects/naif4.webp": 8646,
	"./projects/naif5.webp": 3377,
	"./projects/naifmeat.png": 5681,
	"./projects/test.png": 8370,
	"./projects/zlopes1.jpg": 448,
	"./projects/zlopes2.jpg": 5407,
	"./projects/zlopes3.jpg": 5410,
	"./projects/zlopes4.jpg": 1969,
	"./projects/zlopes5.jpg": 3444,
	"./projects/zlopesbanner.png": 2743,
	"./projects/zlopesmobile.png": 5763,
	"./rashiname.png": 5305,
	"./reactIcon.png": 5545,
	"./right2.svg": 6947,
	"./rightArrow.svg": 1782,
	"./sai.jpeg": 4203,
	"./seriusme.png": 7230,
	"./startfromhere.png": 6629,
	"./testprofile.png": 968,
	"./travelstories.png": 4468,
	"./uiux.png": 3606,
	"./web.png": 9777,
	"./webicon.svg": 440,
	"./website.png": 7796,
	"./wissal.jpeg": 4023,
	"./yesican.png": 2351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;